import { storage } from '../utils/storage';

const API_KEY = 'AIzaSyDbknyG-fT-o7FRvemmjVxiID8g9n7QcYk';
const REFRESH_URL = `https://securetoken.googleapis.com/v1/token?key=${API_KEY}`;

export async function getFreshIdToken(): Promise<string> {
  try {
    // Tenta usar o token salvo primeiro
    const tokenSalvo = await storage.getItem('authToken');
    if (tokenSalvo) {
      // Verificar se o token ainda é válido (simplificado - em produção, validar JWT)
      return tokenSalvo;
    }

    // Se não houver token, tenta renovar com refreshToken
    const refreshToken = await storage.getItem('authRefreshToken');
    if (refreshToken) {
      const response = await fetch(REFRESH_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        }),
      });

      const data = await response.json();
      if (data.id_token) {
        await storage.setItem('authToken', data.id_token);
        if (data.refresh_token) {
          await storage.setItem('authRefreshToken', data.refresh_token);
        }
        return data.id_token;
      }
    }

    // Fallback: login REST com credenciais salvas
    const email = await storage.getItem('emailSalvo');
    const senha = await storage.getItem('senhaSalva');
    
    if (!email || !senha) {
      throw new Error('Credenciais não encontradas. Faça login novamente.');
    }

    const SIGNIN_URL = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${API_KEY}`;
    const resp = await fetch(SIGNIN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password: senha,
        returnSecureToken: true,
      }),
    });

    const data = await resp.json();
    if (!resp.ok || !data?.idToken) {
      throw new Error(data?.error?.message || 'Falha no login REST.');
    }

    await storage.setItem('authToken', data.idToken);
    if (data.refreshToken) {
      await storage.setItem('authRefreshToken', data.refreshToken);
    }

    return data.idToken;
  } catch (error) {
    console.error('Erro ao obter token:', error);
    throw error;
  }
}

export async function fetchWithAuth(
  url: string,
  options: {
    method?: string;
    headers?: Record<string, string>;
    body?: any;
    wrapAsCallableData?: boolean;
  } = {}
): Promise<Response> {
  try {
    const token = await getFreshIdToken();
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    let body = options.body;
    if (options.wrapAsCallableData && body) {
      body = { data: body };
    }

    const response = await fetch(url, {
      method: options.method || 'POST',
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    return response;
  } catch (error) {
    console.error('Erro na requisição autenticada:', error);
    throw error;
  }
}

